
export const serverAppConfig = {
  "storeId": "64f6f5575b1bb5eb8f19e9b9",
  "categories": [
    {
      "id": "65bb652540f2c64ae8776fc8",
      "name": "Maskiner",
      "slug": "maskiner",
      "description": "Popcornmaskiner",
      "thumbnailDescription": "Little Bambino popcornmaskiner",
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/192760_2.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/192760_2.jpg",
      "order": 1,
      "metaTitle": "Grymma popcornmaskiner till fantastiska priser!",
      "metaDescription": "Köp de bästa popcornmaskinerna på americanpopcorn.se",
      "metaHeader": "Popcornmaskiner som gör de bästa popcornen",
      "subCategories": [
        {
          "id": "65bb691f40f2c64ae8776fca",
          "name": "Bänk",
          "slug": "maskiner-bank",
          "description": "Popcornmaskin för bänk",
          "thumbnailDescription": "Popcornmaskin för bänk",
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/001-Little Bambino RED.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/001-Little Bambino RED.jpg",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "65bb695c40f2c64ae8776fce",
          "name": "Golv",
          "slug": "maskiner-golv",
          "description": "Popcornmaskin för golv",
          "thumbnailDescription": "Popcornmaskin för golv",
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/Topstar.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/Topstar.png",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "65bb652f40f2c64ae8776fc9",
      "name": "Tillbehör",
      "slug": "tillbehor",
      "description": "Allt du behöver för den perfekta filmkvällen!",
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/2399-popcornmaskin-for-restaurang-bar-eller-forening-3531.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/2399-popcornmaskin-for-restaurang-bar-eller-forening-3531.jpg",
      "order": 2,
      "metaTitle": "Popcorntillbehör",
      "metaDescription": "Popcorn, popcornbägare och reservdelar till din maskin",
      "metaHeader": "Popcornbägare, popcorn, reservdelar mm",
      "subCategories": [
        {
          "id": "65bb693140f2c64ae8776fcb",
          "name": "Popcorn",
          "slug": "tillbehor-popcorn",
          "description": "Popcorn",
          "thumbnailDescription": "Popcorn",
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/jafen_Pulp_illustration_closeup_of_a_huge_popcorn_classic_pul_e1b3c052-d72b-4dfa-9063-f0d699a90801_1.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1047/tags/jafen_Pulp_illustration_closeup_of_a_huge_popcorn_classic_pul_e1b3c052-d72b-4dfa-9063-f0d699a90801_1.png",
          "order": 1,
          "metaTitle": "Riktiga popcorn från USA",
          "metaDescription": "Köp riktiga amerikanska popcorn som smakar fantastiskt!",
          "metaHeader": "Amerikanska popcorn",
          "subCategories": null
        }
      ]
    }
  ],
  "analytics": {
    "gtmId": "GTM-W22M694G",
    "destinations": [
      {
        "type": "GTM",
        "id": "GTM-T9P8KP9Z",
        "customMapping": null
      }
    ],
    "mode": null,
    "loadStrategy": null,
    "scriptOrigin": null,
    "sendPageView": null
  },
  "privacy": {
    "cmpType": "COOKIE_SCRIPT",
    "cmpId": "21477a9ed7b14f0700dbd7e11c19ab5f",
    "manageConsentDefaults": null,
    "defaultConsent": null
  },
  "assistant": {
    "id": null,
    "name": null,
    "imgUrl": null,
    "company": "American Popcorn"
  },
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "6537c6f279a153613ecc8ed3",
      "name": "Standardleverans 1-2 dagar",
      "label": "Leveranstid 1-2 dagar",
      "buyable": true
    },
    {
      "id": "6583f92d79a153613ecc8ff3",
      "name": "Standardleverans 2-4 dagar - Ej i lager",
      "label": "Ej i lager - Normal leveranstid 2-4 dagar",
      "buyable": true
    }
  ],
  "language": "sv",
  "currency": "SEK",
  "labels": {
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/brands",
    "categoriesUrlPath": "/categories",
    "tagsUrlPath": "/tags",
    "productsUrlPath": "/products",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [
    {
      "id": "blog",
      "label": "Blogg",
      "path": "/blog"
    },
    {
      "id": "minasidor",
      "label": "Mina sidor",
      "path": "/account"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1047/american_popcorn_liggande.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris högt-lågt",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lågt-högt",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyaste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "45vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    200000
  ],
  "freeShippingOver": 499,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 499,
      "deliveryFee": 139
    }
  },
  "paymentProviderConfig": {
    "providerName": "KLARNA",
    "providerOptions": {
      "klarna": {
        "purchaseCountry": "SE",
        "availableCountries": null,
        "purchaseCurrency": "SEK",
        "phoneMandatory": true,
        "colorButton": null,
        "termsUrl": null,
        "cancellationTermsUrl": null
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 200000,
  "topNavHeight": {
    "panel": {
      "base": 0
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "14vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": []
};
export const serverTheme = {
  "colors": {
    "background": {
      "surface": "#ffffff"
    }
  },
  "components": {
    "CustomFooter": {
      "bg": "#f6f5f5",
      "textColor": "#000000"
    },
    "TopNavLogo": {
      "width": "5rem"
    }
  }
}; 
